import { z } from "zod";
import { EstadosIntencionCompra } from "@/constants/enums/status/entity-status-ids";

export interface PurchaseOrderIntentListItem {
  id: number;
  fechaSolicitud?: string;
  titularCuenta?: string;
  cuenta?: number;
  tipoInsumo?: string;
  estadoDescripcion?: string;
  zonaComercial?: string;
}

export interface PurchaseOrderIntentListResponse {
  totalPages: number;
  totalRecords: number;
  listado: PurchaseOrderIntentListItem[];
}

export const purchaseOrderIntentOpenStatusIds = [
  EstadosIntencionCompra.Pendiente,
  EstadosIntencionCompra.EnComunicacion,
];

export const purchaseOrderIntentDefaultValues = {
  estados: purchaseOrderIntentOpenStatusIds.map(String),
};

export const purchaseOrderIntentFiltersSchema = z.object({
  cuenta: z.any().optional(),
  fechaSolicitud: z.any().optional(),
  zonaComercial: z.any().optional(),
  tipoInsumo: z.any().optional(),
  estados: z.any().optional(),
});
